import * as React from 'react';
import type {IEventTemplate} from '../../../types/IEventTemplate';
import {useIsMobile} from '../../../hooks/useIsMobile';
import {CustomAccordion} from '../../accordion/custom-accordion';
import {calculateMeetingStats} from '../../../utils/sequential';
import {BookingInfoHeader} from './booking-info-header.tsx';
import {SequenceTimeline} from './sequence-timeline.tsx';
import css from './sequential-booking-info.css';


interface SequentialBookingInfoProps {
  title: string;
  brandLogo?: string;
  eventTemplate: IEventTemplate;
}

export const SequentialBookingInfo = ({
  title,
  brandLogo,
  eventTemplate,
}: SequentialBookingInfoProps) => {
  const isMobileView = useIsMobile();
  const {sequence = []} = eventTemplate?.metadata || {};
  const stats = React.useMemo(
    () => calculateMeetingStats(eventTemplate),
    [eventTemplate],
  );

  const header = (
    <BookingInfoHeader title={title} brandLogo={brandLogo} stats={stats} />
  );

  const sequenceDetails = (
    <div className={css.sequentialBookingInfoContent}>
      <div className={css.sequenceTimeline}>
        <SequenceTimeline sequence={sequence} eventTemplate={eventTemplate} />
      </div>
    </div>
  );

  return (
    <div className={css.sequentialBookingInfoContainer}>
      {isMobileView ? (
        <CustomAccordion header={header} content={sequenceDetails} />
      ) : (
        <>
          {header}
          {sequenceDetails}
        </>
      )}
    </div>
  );
};
